import React from 'react'
import HomeContentComponent from './homeContent.component'
import NavbarComponent from './navbar.component'

function Home() {
    return (
        <div className='home' id='Home'>
            <NavbarComponent />
            <div className='container mainComponentCenter d-flex flex-column justify-content-center align-items-center mt-lg-0'>
                <h1 className='text-light nav-item-main-head'>
                    <span className='me-lg-5 me-2'>M E H A N D I</span> M A L A B A R
                </h1>
                <p className='text-light nav-item-main-subhead'>
                    " M E H A N D I &nbsp; M A G I C , &nbsp; U N V E I L &nbsp; Y O U R &nbsp; B E A U T Y "
                </p>
                <a
                    href="#Book"
                    className='btn btn-outline-light homeBtn px-lg-5 px-4 rounded-pill nav-item-head mt-lg-5 ms-0'
                    aria-label="Book a mehandi appointment"
                >
                    B o o k &nbsp; N o w
                </a>
            </div>
        </div>
    )
}

export default Home
